/**
 * Fuente de las opciones del desplegable de Marca en Tendencias y Exportar (PT-#91).
 *
 * Antes ambos forzaban `/distinct-tag/MARCA` (tabla EAV `tags`). Para clientes SIN merge de
 * marca con catalog (Adidas, LG) esa tabla no es la fuente de Marca: en Adidas está congelada
 * (126 marcas de 167 en toma_80) y en LG no existe. Para ellos se usa la misma fuente que
 * Publicaciones: `/distinct/<columna de marca>`, que respeta mergeWithCatalog y si no hay merge
 * lee la columna de la toma.
 *
 * Clientes CON merge (Samsung, TIA) quedan en `/distinct-tag/MARCA` para no cambiar su
 * desplegable en este PR (medido 13/10/2026: Samsung 866 marcas por tags vs 1.381 en
 * Publicaciones; TIA 2 vs 4.593). Pasarlos a la fuente de Publicaciones es una decisión aparte.
 */

const BRAND_COLUMN_CANDIDATES = ['marca', 'brand'];

/** Nombre real de la columna de marca en el schema de la toma (default 'Marca'). */
export function detectBrandColumn(schema: Array<{ Field?: string }> | null | undefined): string {
  if (Array.isArray(schema)) {
    const hit = schema.find(c => typeof c?.Field === 'string' && BRAND_COLUMN_CANDIDATES.includes(c.Field.toLowerCase()));
    if (hit?.Field) return hit.Field;
  }
  return 'Marca';
}

/** ¿El cliente mergea la marca con catalog? (mismo criterio que Dashboard.loadTableSchema) */
export function hasBrandCatalogMerge(columnConfig: any): boolean {
  const marca = columnConfig?.core?.marca;
  return !!(marca && marca.enabled !== false && marca.mergeWithCatalog);
}

/**
 * Path (sin `?withCounts`) del endpoint de opciones de Marca. Devuelve string[] en modo legacy.
 * PT-#87 PR-d: `clientUsesTags` = enable_tags del cliente (default true). Un cliente con merge
 * que NO usa tags (modelo catalog puro, ej. Adidas tras el switch) usa la fuente de Publicaciones
 * (`/distinct/<Marca>`, merge-aware): la tabla `tags` no es su fuente (vacía tras la purga o
 * congelada: 126 de 167 marcas en toma_80).
 */
export function brandOptionsPath(
  tableName: string,
  columnConfig: any,
  schema?: Array<{ Field?: string }> | null,
  clientUsesTags: boolean = true,
): string {
  if (hasBrandCatalogMerge(columnConfig) && clientUsesTags) {
    return `/api/tables/${tableName}/distinct-tag/MARCA`;
  }
  return `/api/tables/${tableName}/distinct/${encodeURIComponent(detectBrandColumn(schema))}`;
}
